// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 535) return "static/chunks/535.62ec14b42a4d471d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"7763":"e7ddfa078123aa0e","8522":"45a52a1c8f79bb82"}[chunkId] + ".js";
};